import * as React from 'react';
import {observer} from 'mobx-react';
import {PageCheckoutPanelProps} from './page-checkout-panels';
import {Alert} from './alert';
import {style} from 'typestyle';
import {important, px} from 'csx';
import {ImagePreloader} from '../types/fn';
import {PageCheckoutDownloadTracks} from "./page-checkout-download-tracks";
import {AnalyticsController} from "../modules/analytics/controller";

export interface PageCheckoutContentStep3Props extends PageCheckoutPanelProps {
  PlayButton: any;
  BrandSponsoredLabel: any;
  Share?: any;
  preload: ImagePreloader;
  preloadWaveform: ImagePreloader;
  onDownload?(licenceId: string): void;
  onAttribution?(licenceId: string): void;
  onClickLink(event: React.MouseEvent<any>): void;
  i18n?: {
    title: string;
  };
  analytics: AnalyticsController;
}

const DEFAULT_I18N = {
  title: 'Thank you for your purchase'
};

@observer
export class PageCheckoutContentStep3 extends React.Component<PageCheckoutContentStep3Props, {}> {
  render() {
    const { model, Share, i18n = DEFAULT_I18N, PlayButton, BrandSponsoredLabel, preload, preloadWaveform, onDownload, onAttribution, onClickLink, analytics } = this.props;
    return (
      <div>
        <h5>{i18n.title}</h5>
        <PageCheckoutDownloadTracks
          analytics={analytics}
          PlayButton={PlayButton}
          BrandSponsoredLabel={BrandSponsoredLabel}
          model={model}
          collapsed={false}
          download={true}
          preload={preload}
          preloadWaveform={preloadWaveform}
          onDownload={onDownload}
          onAttribution={onAttribution}
          onClickLink={onClickLink}
        />
        {Share && (
          <Alert type="simple" position="none" className={PageCheckoutContentStep3.styles.shareBox}>
            <Share />
          </Alert>
        )}
      </div>
    )
  }

  static styles = {
    shareBox: style({
      maxWidth: px(960),
      marginLeft: important('auto'),
      marginRight: important('auto')
    })
  }
}